module.exports = __webpack_public_path__ + "img/marita_huurinainen.3d5d4979.png";